import request from '@plat-components/utils2/_esm5/request';
import { lock, unlock } from 'tua-body-scroll-lock';
import biliActEvents from '@bilibili/bili-act-events';
import { preloadImages, jumpLogin } from '../common/utils';
import { setSize, createDiv, dialogAddClass, dialogDeleteClass, deleteDOM, getCookie, setChannelKey, showWarning, } from '../common/utils';
var urls = {
    nav: 'https://api.bilibili.com/x/web-interface/nav',
    vcShare: 'https://api.vc.bilibili.com/dynamic_repost/v1/dynamic_repost/share',
    vcCreateDraw: 'https://api.vc.bilibili.com/dynamic_svr/v1/dynamic_svr/create_draw'
};
biliActEvents.on('SHARE_H5_NEXT_MODIFY_DYNAMIC_URLS', function (u) {
    var vcShare = u.vcShare, vcCreateDraw = u.vcCreateDraw, nav = u.nav;
    if (nav) {
        urls.nav = nav;
    }
    if (vcShare) {
        urls.vcShare = vcShare;
    }
    if (vcCreateDraw) {
        urls.vcCreateDraw = vcCreateDraw;
    }
});
export default function biliDialog(share) {
    var dialogDom = document.getElementsByClassName('share-dynamic-dialog')[0];
    var uid = '';
    var useCard = share.bili.type !== 'image';
    initBiliDialog();
    function initBiliDialog() {
        var font_size = share.font_size, templateEl = share.templateEl;
        var _a = share.bili, title = _a.title, pics = _a.pics, desc = _a.desc, text_area = _a.text_area;
        if (!dialogDom) {
            var dialog = "\n        <div class=\"share-dynamic-dialog mobile\">\n          <div class=\"sdd-head\">\n            <span>\u5206\u4EAB\u81F3\u52A8\u6001</span>\n            <i class=\"sdd-close\"></i>\n          </div>\n          <div class=\"sdd-body-wrap\">\n            <textarea class=\"sdd-input\" placeholder=\"\u8BF4\u70B9\u4EC0\u4E48...\">" + text_area + "</textarea>\n            " + (useCard ?
                "<div class=\"sdd-card\">\n                <div class=\"name\">@" + title + "</div>\n                <div class=\"sdd-card-content\">\n                  <div class=\"pic\" style=\"background-image: url('" + pics + "')\"></div>\n                  <div class=\"title\">" + title + "</div>\n                  <div class=\"summary\">" + desc + "</div>\n                </div>\n              </div>" :
                "<div class=\"sdd-card-pic-wrapper\">\n                <div class=\"pic\" style=\"background-image: url('" + pics + "')\"></div>\n              </div>") + "\n          </div>\n          <div class=\"sdd-action-bar\">\n            <div class=\"sdd-submit\">\u53D1\u5E03</div>\n            <div class=\"sdd-input-num\">233</div>\n          </div>\n        </div>\n      ";
            createDiv(dialog, { fontSize: setSize(font_size) }, templateEl);
            dialogDom = document.getElementsByClassName('share-dynamic-dialog')[0];
        }
        getUserId();
        biliDialogShow(dialogDom, true);
        bindDialogEvent();
    }
    function biliDialogShow($el, status) {
        if (status) {
            setTimeout(function () {
                lock(dialogDom);
                dialogAddClass($el, 'active');
            }, 300);
        }
        else {
            unlock(dialogDom);
            dialogDeleteClass($el, 'active');
        }
    }
    function bindDialogEvent() {
        var close = document.getElementsByClassName('sdd-close')[0];
        var input = document.getElementsByClassName('sdd-input')[0];
        var num = document.getElementsByClassName('sdd-input-num')[0];
        var submit = document.getElementsByClassName('sdd-submit')[0];
        var _a = share.bili, title = _a.title, pics = _a.pics, desc = _a.desc, link = _a.link, text_area = _a.text_area;
        var text = text_area;
        close.addEventListener('click', function () {
            biliDialogShow(dialogDom, false);
            deleteDOM(dialogDom, 200);
        });
        input.addEventListener('input', function (ev) {
            var target = ev.target;
            text = target.value;
            var length = 233 - target.textLength;
            num.innerHTML = '' + length;
            length < 0
                ? (dialogAddClass(num, 'warning'), dialogAddClass(submit, 'disable'))
                : (dialogDeleteClass(num, 'warning'),
                    dialogDeleteClass(submit, 'disable'));
        });
        var postCardDynamic = function () {
            return request({
                method: 'post',
                url: urls.vcShare,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: {
                    uid: 0,
                    type: 2048,
                    share_uid: uid,
                    content: text,
                    repost_code: 40000,
                    csrf_token: getCookie('bili_jct'),
                    sketch: {
                        title: title,
                        desc_text: desc,
                        biz_type: share.biz_type || 3,
                        cover_url: pics,
                        target_url: setChannelKey(link, 'bili')
                    }
                }
            });
        };
        var postCreateDraw = function () {
            return preloadImages(pics ? [pics] : []).then(function (imgs) {
                return request({
                    method: 'post',
                    url: urls.vcCreateDraw,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    timeout: 6000,
                    data: {
                        biz: 3,
                        category: 3,
                        type: 0,
                        title: '',
                        tags: '',
                        description: text,
                        pictures: JSON.stringify(imgs.map(function (img) {
                            return {
                                img_src: img.src,
                                img_width: img.width,
                                img_height: img.height,
                                img_size: 500,
                            };
                        })),
                    },
                });
            });
        };
        submit.addEventListener('click', function () {
            if (document.querySelector('.sdd-submit.disable'))
                return;
            var success = share.success, cancel = share.cancel;
            var postPromise = useCard ? postCardDynamic : postCreateDraw;
            postPromise()
                .then(function () {
                if (typeof success === 'function') {
                    success({
                        platform: 'bili'
                    });
                }
                biliDialogShow(dialogDom, false);
                deleteDOM(dialogDom, 200);
                showSuccess();
            })
                .catch(function (error) {
                if (typeof cancel === 'function') {
                    cancel(error);
                }
                switch (+error.code) {
                    case -6:
                        jumpLogin();
                        break;
                    default:
                        showWarning(error.message ||
                            error.msg ||
                            '服务器出问题啦～请稍后在分享吧～');
                }
            });
        });
    }
    function getUserId() {
        request({
            method: 'get',
            url: urls.nav
        })
            .then(function (res) {
            if (res.code == 0) {
                uid = res.data.mid;
            }
            else if (res.code === -101) {
                jumpLogin();
            }
        })
            .catch(function (err) {
            if (err.code === -101) {
                jumpLogin();
            }
        });
    }
    function showSuccess() {
        var dialogSuccess = document.getElementsByClassName('share-success-dialog')[0];
        if (!dialogSuccess) {
            var html = "\n        <div class=\"share-success-mask on\"></div>\n        <div class=\"share-success-dialog mobile\">\n          <div class=\"suc-img\"></div>\n          <div class=\"info\">\u5206\u4EAB\u6210\u529F</div>\n          <div class=\"hint\">\u8BF7\u5728\u5BA2\u6237\u7AEF\u4E2D\u67E5\u770B~</div>\n          <div class=\"dialog-close \">\u786E\u5B9A</div>\n        </div>\n      ";
            createDiv(html, { fontSize: setSize(share.font_size) }, share.templateEl);
            dialogSuccess = document.getElementsByClassName('share-success-dialog')[0];
        }
        biliDialogShow(dialogSuccess, true);
        bindSuccess(dialogSuccess);
    }
    function bindSuccess(dialogSuccess) {
        var mask = document.getElementsByClassName('share-success-mask')[0];
        var close = document.getElementsByClassName('dialog-close')[0];
        close.addEventListener('click', function () {
            biliDialogShow(dialogSuccess, false);
            setTimeout(function () {
                dialogDeleteClass(mask, 'on');
                deleteDOM(dialogSuccess, 200);
            }, 100);
        });
    }
}
